import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const PaymentResponse = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Processing...');

  useEffect(() => {
    const handlePaymentResponse = async () => {
      try {
        // Debug logs to check what we're receiving
        console.log('Full URL:', window.location.href);
        console.log('Search Params:', location.search);
        
        // Get all URL parameters
        const params = new URLSearchParams(location.search);
        
        // Log each parameter individually
        console.log('txnid:', params.get('txnid'));
        console.log('amount:', params.get('amount'));
        console.log('productinfo:', params.get('productinfo'));
        console.log('status:', params.get('status'));
        console.log('error_Message:', params.get('error_Message'));
        console.log('hash:', params.get('hash'));

        const paymentData = {
          txnid: params.get('txnid'),
          amount: params.get('amount'),
          productinfo: params.get('productinfo'),
          status: params.get('status'),
          error_Message: params.get('error_Message'),
          hash: params.get('hash')
        };

        console.log('Payment Data:', paymentData);

        // Make API call to verify payment
        const response = await axios.post('/api/payments/payu/callback', paymentData);
        
        if (response.data.success) {
          setStatus('Payment Successful!');
          // Redirect to orders page after 2 seconds
          setTimeout(() => {
            navigate('/user/orders');
          }, 2000);
        } else {
          setStatus('Payment Failed: ' + response.data.message);
        }
      } catch (error) {
        console.error('Payment Error:', error);
        setStatus('Error processing payment: ' + error.message);
      }
    };

    handlePaymentResponse();
  }, [location, navigate]);

  return (
    <div className="payment-response-container text-center p-5">
      <h2>{status}</h2>
      <p>Please wait while we redirect you...</p>
      {/* Add debug information to the UI */}
      <div style={{ display: 'none' }}>
        <p>Debug Info:</p>
        <p>URL: {window.location.href}</p>
        <p>Search Params: {location.search}</p>
      </div>
    </div>
  );
};

export default PaymentResponse; 